import React, { useState, useEffect } from "react";
import "../styles/AdminDashboard.css";

function AdminDashboard() {
  const [password, setPassword] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loginError, setLoginError] = useState("");

  // Check if already authenticated
  useEffect(() => {
    const isAuth = localStorage.getItem("adminAuth") === "true";
    if (isAuth) {
      setIsAuthenticated(true);
    }
  }, []);

  // Handle login
  const handleLogin = (e) => {
    e.preventDefault();
    setLoginError("");

    // Replace with your actual password (use environment variable in production)
    const adminPassword = "Engineer@K123";

    if (password === adminPassword) {
      localStorage.setItem("adminAuth", "true");
      setIsAuthenticated(true);
      setPassword("");
    } else {
      setLoginError("Invalid password. Please try again.");
      setPassword("");
    }
  };

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem("adminAuth");
    setIsAuthenticated(false);
    setPassword("");
  };

  // Login View
  if (!isAuthenticated) {
    return (
      <div className="admin-container">
        <div className="login-box">
          <h1>Admin Dashboard</h1>
          <p className="login-subtitle">Quotation Management System</p>

          <form onSubmit={handleLogin} className="login-form">
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {loginError && <div className="error-message">{loginError}</div>}

            <button type="submit" className="login-btn">
              Sign In
            </button>
          </form>

          <p className="login-footer">
            For security, only authorized users can access this area.
          </p>
        </div>
      </div>
    );
  }

  // Dashboard View
  return (
    <div className="admin-container">
      <div className="dashboard">
        {/* Header */}
        <div className="dashboard-header">
          <div>
            <h1>Dashboard</h1>
            <p>Quotation Management System</p>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>

        {/* Content */}
        <div className="dashboard-content">
          <div className="card">
            <h2>How It Works</h2>
            <ol className="steps">
              <li>
                <strong>Clients Submit Requests</strong> - They fill out the
                quotation form on your website
              </li>
              <li>
                <strong>Instant Email Notification</strong> - You receive an
                email immediately at:
                <p className="email-address">securedev001@gmail.com</p>
              </li>
              <li>
                <strong>Complete Information</strong> - Includes client details,
                project scope, budget, and timeline
              </li>
              <li>
                <strong>Direct Response</strong> - Reply to the email or contact
                the client via phone/WhatsApp
              </li>
            </ol>
          </div>

          <div className="card">
            <h2>Email Details Provided</h2>
            <div className="details-list">
              <div className="detail-item">
                <span className="label">Client Name:</span>
                <span className="value">From form submission</span>
              </div>
              <div className="detail-item">
                <span className="label">Email:</span>
                <span className="value">From form submission</span>
              </div>
              <div className="detail-item">
                <span className="label">Phone:</span>
                <span className="value">From form submission</span>
              </div>
              <div className="detail-item">
                <span className="label">Company:</span>
                <span className="value">From form submission</span>
              </div>
              <div className="detail-item">
                <span className="label">Service Needed:</span>
                <span className="value">Auto-filled from service page</span>
              </div>
              <div className="detail-item">
                <span className="label">Project Scope:</span>
                <span className="value">Small, Medium, Large, Ongoing</span>
              </div>
              <div className="detail-item">
                <span className="label">Budget Range:</span>
                <span className="value">Client's budget selection</span>
              </div>
              <div className="detail-item">
                <span className="label">Timeline:</span>
                <span className="value">
                  ASAP, 1 Month, 2-3 Months, 3+ Months
                </span>
              </div>
            </div>
          </div>

          <div className="card">
            <h2>Professional Tips</h2>
            <ul className="tips-list">
              <li>
                ✓ <strong>Check emails daily</strong> for new quotation requests
              </li>
              <li>
                ✓ <strong>Respond within 24 hours</strong> - Shows
                professionalism
              </li>
              <li>
                ✓ <strong>Use professional tone</strong> - Keep it business-like
              </li>
              <li>
                ✓ <strong>Provide detailed quotes</strong> - Include breakdown
                and timeline
              </li>
              <li>
                ✓ <strong>Set up email filters</strong> - Organize quotations in
                folders
              </li>
              <li>
                ✓ <strong>Follow up</strong> - Call or WhatsApp after 48 hours
              </li>
            </ul>
          </div>

          <div className="card">
            <h2>Email Template Response</h2>
            <div className="template">
              <p>
                <strong>Subject:</strong> Re: Quotation Request for [Service]
              </p>
              <br />
              <p>Dear [Client Name],</p>
              <p>
                Thank you for your quotation request for
                <strong> [Service]</strong>.
              </p>
              <p>
                We've reviewed your project requirements and would like to
                present our proposal:
              </p>
              <ul>
                <li>
                  <strong>Service:</strong> [Service Type]
                </li>
                <li>
                  <strong>Estimated Cost:</strong> [Amount]
                </li>
                <li>
                  <strong>Timeline:</strong> [Number] weeks/days
                </li>
                <li>
                  <strong>Deliverables:</strong> [List items]
                </li>
              </ul>
              <p>
                We'd like to discuss this further. Would you be available for a
                call this week?
              </p>
              <p>
                You can reach us at:
                <br />
                📱 WhatsApp: +256 743 678 908
                <br />
                📧 Email: securedev001@gmail.com
              </p>
              <p>
                Best regards,
                <br />
                <strong>Engineer K</strong>
                <br />
                Professional Tech Solutions
              </p>
            </div>
          </div>

          <div className="card">
            <h2>Quick Stats</h2>
            <div className="stats-grid">
              <div className="stat">
                <div className="stat-number">12</div>
                <div className="stat-label">Projects Completed</div>
              </div>
              <div className="stat">
                <div className="stat-number">30+</div>
                <div className="stat-label">Satisfied Clients</div>
              </div>
              <div className="stat">
                <div className="stat-number">4</div>
                <div className="stat-label">Core Services</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
